/**
 * expenditure-resolution (지출결의서) orval 래퍼
 *
 * orval 생성 함수를 기존 SDK 패턴(expenditureResolutionApi.xxx)으로 래핑한다.
 * 기존 코드에서 import 경로만 바꾸면 되도록 동일한 인터페이스를 제공한다.
 *
 * 전환 완료 후 기존 `packages/shared/api/nest/expenditure-resolution.api.ts`는 삭제한다.
 *
 * NOTE: cancelSubmission은 현재 OpenAPI spec에 미포함 — orval 생성 함수 없음.
 * 백엔드 Swagger 데코레이터 추가 후 래퍼에 반영 예정.
 */
import { get } from "../endpoints/지출결의서/지출결의서";
import { customInstance } from "../custom-instance";
// orval이 생성한 factory에서 API 함수들을 꺼낸다
const generated = get();
// ── 기존 SDK와 동일한 인터페이스 ──
async function getExpenditureResolutions(params) {
    return customInstance({
        url: "/expenditure-resolution",
        method: "GET",
        params,
    });
}
async function getExpenditureResolution(id) {
    return generated.expenditureResolutionControllerGetOne(id);
}
async function createExpenditureResolution(body) {
    return generated.expenditureResolutionControllerPostCreate(body);
}
async function updateExpenditureResolution(id, body) {
    return generated.expenditureResolutionControllerPatchUpdate(id, body);
}
async function submitExpenditureResolution(id) {
    return generated.expenditureResolutionControllerPatchSubmit(id);
}
async function markPaymentComplete(id, body = {}) {
    return generated.expenditureResolutionControllerPatchPayment(id, body);
}
async function cancelSubmission(id) {
    return customInstance({
        url: `/expenditure-resolution/${id}/cancel`,
        method: "PATCH",
    });
}
async function deleteExpenditureResolution(id) {
    return generated.expenditureResolutionControllerDeleteOne(id);
}
// ── SDK 객체 (기존 expenditureResolutionApi와 동일 shape) ──
export const expenditureResolutionApi = {
    getExpenditureResolutions,
    getExpenditureResolution,
    createExpenditureResolution,
    updateExpenditureResolution,
    submitExpenditureResolution,
    cancelSubmission,
    markPaymentComplete,
    deleteExpenditureResolution,
};
